import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import SectorPage from "@/pages/SectorPage";
import ClaimForm from "@/pages/ClaimForm";
import ThankYou from "@/pages/ThankYou";
import HowItWorksPage from "@/pages/HowItWorksPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function PublicLayout({ children }) {
    return (
        <div className="App flex flex-col min-h-screen bg-slate-50">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
            <StickyMobileCTA />
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                    <Route path="/sectors/:slug" element={<PublicLayout><SectorPage /></PublicLayout>} />
                    <Route path="/claim" element={<PublicLayout><ClaimForm /></PublicLayout>} />
                    <Route path="/thank-you" element={<PublicLayout><ThankYou /></PublicLayout>} />
                    <Route path="/how-it-works" element={<PublicLayout><HowItWorksPage /></PublicLayout>} />
                    <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
                    <Route path="/faq" element={<PublicLayout><FAQPage /></PublicLayout>} />
                    <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
                    <Route path="/legal/:slug" element={<PublicLayout><LegalPage /></PublicLayout>} />

                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin/dashboard"
                        element={
                            <ProtectedRoute>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />

                    <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="top-right" />
        </AuthProvider>
    );
}

export default App;
